import { AreaStateAggregateType } from "@/routes/area-aggregate/types/area-state-aggregate.type";
import { ModuleCommandEnum } from "@/types/enums/module-command.enum";

export const computeModulesSumByState = (
  areaStateAggregate: AreaStateAggregateType,
  command: ModuleCommandEnum
) => {
  let result: {
    numberOfModulesAchieved: number;
    percentageOfModulesAchieved: number;
    isCompleted: boolean;
  } | null = null;

  switch (command) {
    case ModuleCommandEnum.OPEN:
      result = {
        numberOfModulesAchieved: areaStateAggregate.numberOfUnfoldedModules,
        percentageOfModulesAchieved:
          areaStateAggregate.percentageOfUnfoldedModules,
        isCompleted:
          areaStateAggregate.unfoldedModules.length ===
          areaStateAggregate.numberOfModulesInArea,
      };
      break;
    case ModuleCommandEnum.CLOSE:
    case ModuleCommandEnum.UP:
      result = {
        numberOfModulesAchieved: areaStateAggregate.numberOfUpModules,
        percentageOfModulesAchieved: areaStateAggregate.percentageOfUpModules,
        isCompleted:
          areaStateAggregate.upModules.length ===
          areaStateAggregate.numberOfModulesInArea,
      };
      break;
    case ModuleCommandEnum.DOWN:
      result = {
        numberOfModulesAchieved: areaStateAggregate.numberOfFoldedModules,
        percentageOfModulesAchieved:
          areaStateAggregate.percentageOfFoldedModules,
        isCompleted:
          areaStateAggregate.foldedModules.length ===
          areaStateAggregate.numberOfModulesInArea,
      };
      break;
  }

  if (!result) {
    throw new Error("No result found");
  }

  return result;
};
